import { useTranslation } from 'react-i18next';
import { type DealDocument } from '@/services/requests/housien-services/DealsService';
import { DocumentsTab } from '@/shared/ui/components/composed/documents-tab/DocumentsTab';

interface DealDocumentsInlineProps {
  documents: DealDocument[];
  loading: boolean;
  error: string | null;
  onUpload: (file: File) => Promise<void>;
  onDelete: (documentId: string) => Promise<void>;
  onRename: (documentId: string, filename: string) => Promise<void>;
}

/**
 * Deal documents tab: thin wrapper around the shared `DocumentsTab`, bound
 * to the `features/deals` i18n namespace — mirrors the property and client
 * document tabs so upload, rename, delete and the empty/error states all
 * look and behave the same across the app.
 */
export function DealDocumentsInline({
  documents,
  loading,
  error,
  onUpload,
  onDelete,
  onRename,
}: DealDocumentsInlineProps) {
  const { t } = useTranslation('features/deals');

  return (
    <DocumentsTab<DealDocument>
      documents={documents}
      loading={loading}
      error={error}
      onUpload={onUpload}
      onDelete={onDelete}
      onRename={onRename}
      title={t('detail.documents.title')}
      errorMessage={t('detail.documents.loadError', { error })}
      emptyMessage={t('detail.documents.empty')}
      uploadLabel={t('detail.documents.upload')}
      i18nNamespace="features/deals"
      i18nKeyPrefix="detail.documents"
    />
  );
}

export default DealDocumentsInline;
